import React from 'react';
import { ControlLink } from '@moda/om';
import './EditableSection.scss';

interface Props {
  onChange?: () => void;
  changeLabel?: string;
  children?: React.ReactNode;
}

export const EditableSection: React.FC<Props> = ({
  changeLabel = 'Change',
  onChange,
  children
}) => (
  <div className="EditableSection">
    {children}

    {onChange && (
      <ControlLink data-test-id={`editable-section-${changeLabel}`} onClick={onChange}>
        {changeLabel}
      </ControlLink>
    )}
  </div>
);
